import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["innerHTML"]

import { reactive, ref } from 'vue';

import { email, required } from '@vuelidate/validators';

import { useResetUserPasswordRequestMutation } from '@/entities/user/hooks';

import {
  NkForm,
  NkFormItem,
  NkCenter,
  NkContainer,
  NkInputText,
  NkButton,
  NkHeading,
  NkStack,
} from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkForgottenPassword',
  setup(__props) {

const form = ref();

const fields = reactive({
  email: '',
});

const rules = {
  email: {
    required,
    email,
  },
};

const { mutateAsync, isLoading, isError, error, isSuccess } = useResetUserPasswordRequestMutation();

const handleSubmit = () => {
  form.value.validator.$validate()
    .then((valid: boolean) => {
      if (valid) mutateAsync(fields).then(() => {
        form.value.validator.$reset();
        fields.email = '';
      });
    });
};

return (_ctx: any,_cache: any) => {
  const _component_ElAlert = _resolveComponent("ElAlert")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(NkContainer), {
    size: "sm",
    class: "py-64"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkStack), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NkForm), {
            ref_key: "form",
            ref: form,
            rules: rules,
            fields: fields
          }, {
            header: _withCtx(() => [
              (_unref(error))
                ? _withDirectives((_openBlock(), _createBlock(_component_ElAlert, {
                    key: 0,
                    "show-icon": "",
                    type: "error"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(error).response.data.message == 'User does not exist.' ?
              _ctx.$t('user.form.notification.forgotten_password.not_valid') :
              _ctx.$t('user.form.notification.forgotten_password.error')), 1)
                    ]),
                    _: 1
                  }, 512)), [
                    [_vShow, _unref(isError) && !_unref(isSuccess)]
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_ElAlert, {
                "show-icon": "",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('user.form.notification.forgotten_password.success')
                  }, null, 8, _hoisted_1),
                  _createVNode(_component_router_link, {
                    class: "ml-2 underline transition hover:opacity-80",
                    to: {name: 'security-login'}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('actions.back_to_login')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _unref(isSuccess) && !_unref(isError)]
              ]),
              _createVNode(_unref(NkCenter), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkHeading), { type: "small-bold" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('user.form.label.forgotten_password')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
                icon: "NkLogin",
                onClick: handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.submit')), 1)
                ]),
                _: 1
              })), [
                [_directive_loading, _unref(isLoading)]
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(NkFormItem), {
                label: _ctx.$t('user.form.label.email'),
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkInputText), {
                    type: "email",
                    name: "email",
                    modelValue: fields.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.email) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["fields"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})